<div class="search-modal">
  <h2 mat-dialog-title>Buscar</h2>
  <div class="close-container">
    <button class="close" (click)="onCancel()">
      <i class="fa-solid fa-xmark" alt=""></i>
    </button>
  </div>

  <!--
    <div class="modal-header">
      <h2>Buscar</h2>
      <button mat-icon-button (click)="onCancel()">
        <i class="fa-solid fa-times"></i>
      </button>
    </div>
  -->

  <!-- Barra de búsqueda principal -->
  <div class="py-3 px-4 flex justify-between items-center">
    <button mat-button class="button button-outlined-priamry" (click)="toggleFilters()">
      Filtros
      <i *ngIf="showFilters == false" class="fa-solid fa-filter"></i>
      <i *ngIf="showFilters == true" class="fa-solid fa-times"></i>
    </button>

    <div class="flex w-[85%]">
      <input 
        class="input me-2"
        type="search" 
        placeholder="Buscar..."
        [(ngModel)]="searchText">
      
      <button class="button button-primary" (click)="onSearch()">
        Buscar
      </button>
    </div>
    
  </div>

  <!-- Panel de filtros -->
  <div *ngIf="showFilters" class="p-4">
    <div class="mb-3">
      <label class="block text-sm font-bold mb-2">Area</label>
      <select class="select" [(ngModel)]="selectedArea">
        <option [value]="0">Todas</option>
        <option *ngFor="let area of updateAreas" [value]="area.id">{{ area.name }}</option>
      </select>
    </div>

    <div class="mb-4">
      <label class="block text-sm font-bold mb-2">Tipo</label>
      <select class="select" [(ngModel)]="selectedType">
        <option [value]="0">Todos</option>
        <option *ngFor="let type of updateTypes" [value]="type.id">{{ type.name }}</option>
      </select>
    </div>

    <button class="button button-outlined-primary w-full mb-4" (click)="toggleDatePickers()">
      <i class="fa-solid fa-calendar-days"></i>
      Fecha
    </button>

    <div class="grid grid-cols-2 gap-4" *ngIf="showDatePickers">
      <div>
        Fecha desde
        <mat-form-field appearance="outline">
          <input matInput 
                 [matDatepicker]="fromPicker" 
                 [(ngModel)]="fromDate"
                 placeholder="DD/MM/YYYY">
          <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
          <mat-datepicker #fromPicker></mat-datepicker>
        </mat-form-field>
      </div>

      <div>
        Fecha hasta
        <mat-form-field appearance="outline">
          <input matInput 
                 [matDatepicker]="toPicker" 
                 [(ngModel)]="toDate"
                 placeholder="DD/MM/YYYY">
          <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
          <mat-datepicker #toPicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </div>

  <!-- Tabla de resultados -->
  <div class="p-4" *ngIf="searchResults.length > 0">
    <h3>Resultados de búsqueda ({{ searchResults.length }} registros)</h3>
    
    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" class="results-table">
      
      <!-- Columna Área -->
      <ng-container matColumnDef="area">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Área</th>
        <td mat-cell *matCellDef="let row">{{ row.area }}</td>
      </ng-container>

      <!-- Columna Tipo -->
      <ng-container matColumnDef="tipo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo</th>
        <td mat-cell *matCellDef="let row">{{ row.tipo }}</td>
      </ng-container>

      <!-- Columna Fecha -->
      <ng-container matColumnDef="fecha">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha</th>
        <td mat-cell *matCellDef="let row">{{ row.fecha | date:'dd/MM/yyyy' }}</td>
      </ng-container>

      <!-- Columna Hora -->

      <!-- Columna Detalle -->
      <ng-container matColumnDef="detalle">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Detalle</th>
        <td mat-cell *matCellDef="let row">{{ row.detalle }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      
    </table>
    
    <!-- Paginador -->
    <mat-paginator [pageSizeOptions]="[5, 10, 20, 50]" showFirstLastButtons></mat-paginator>
  </div>
  
  <!-- Mensaje cuando no hay resultados -->
   <!--
    <div class="p-4 text-center" *ngIf="searchResults.length === 0 && dataSource.data.length === 0">
      <p>No se encontraron resultados. Realiza una búsqueda para ver los datos.</p>
    </div>
  -->
  <div class="p-4 text-center" *ngIf="searchResults.length === 0 && dataSource.data.length === 0">
    <p>No se encontraron resultados. Realiza una búsqueda para ver los datos.</p>
  </div>
</div>
